import { configureStore } from '@reduxjs/toolkit';
import tzReducer from './tz/reducer';
import tasksReducer from './tasksSlice';
import interfaceReducer from './interfaceSlice';
import brandNameReducer from './brandNameSlice';
import analogGeneratorReducer from './analogGeneratorSlice';
import wipoReducer from './wipoSlice';
import searchReducer from './searchSlice';
import imageDescriptionReducer from './imageDescriptionSlice';
import globalSearchReducer from './globalSearchSlice';

export const store = configureStore({
  reducer: {
    tz: tzReducer,
    search: searchReducer,
    tasks: tasksReducer,
    interface: interfaceReducer,
    brandName: brandNameReducer,
    analogGenerator: analogGeneratorReducer,
    wipo: wipoReducer,
    imageDescription: imageDescriptionReducer,
    globalSearch: globalSearchReducer,
  },
});
